import { render, staticRenderFns } from "./task.vue?vue&type=template&id=ddd184c6&"
import script from "./task.vue?vue&type=script&lang=js&"
export * from "./task.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports